"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const INITIAL_STATE = {
    admin: null,
    allowedRoutes: []
};
scrollBy;
const stateReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'refresh-admin':
            return Object.assign(Object.assign({}, state), { admin: action.admin });
        case 'setAllowedRoutes':
            return Object.assign(Object.assign({}, state), { allowedRoutes: action.allowedRoutes });
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    state: stateReducer
});
